
import { NgModule } from '@angular/core';
import { PinLoginComponent } from './pin-login';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    PinLoginComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
})
export class PinLoginPageModule {}
